import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import {
  Container, Box, Typography, TextField, Button, Card, CardContent,
  Alert, Link,
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { authService } from '../../services/authService';

const CompanyRegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({
    companyName: '', contactPerson: '', email: '', password: '', confirmPassword: '',
    phone: '', website: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (form.password !== form.confirmPassword) {
      setError('パスワードが一致しません');
      return;
    }
    if (form.password.length < 8) {
      setError('パスワードは8文字以上で入力してください');
      return;
    }

    setLoading(true);
    try {
      const res = await authService.companyRegister({
        email: form.email,
        password: form.password,
        companyName: form.companyName,
        contactPerson: form.contactPerson,
        phone: form.phone || undefined,
        website: form.website || undefined,
      });
      login(res.data.token, res.data.user);
      navigate('/company/dashboard', { replace: true });
    } catch (err: any) {
      setError(err.response?.data?.message || '登録に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5', py: 6 }}>
      <Container maxWidth="sm">
        <Card>
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, textAlign: 'center' }}>
              企業アカウント登録
            </Typography>
            <Typography variant="body2" sx={{ mb: 3, textAlign: 'center', color: '#666' }}>
              アスリート人材のプロフィール検索・スカウトが可能になります
            </Typography>

            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            <Box component="form" onSubmit={handleSubmit}>
              <TextField
                label="会社名"
                fullWidth
                required
                value={form.companyName}
                onChange={(e) => setForm({ ...form, companyName: e.target.value })}
                sx={{ mb: 2 }}
              />
              <TextField
                label="担当者名"
                fullWidth
                required
                value={form.contactPerson}
                onChange={(e) => setForm({ ...form, contactPerson: e.target.value })}
                sx={{ mb: 2 }}
              />
              <TextField
                label="メールアドレス"
                type="email"
                fullWidth
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                sx={{ mb: 2 }}
              />
              <TextField
                label="電話番号（任意）"
                fullWidth
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                sx={{ mb: 2 }}
              />
              <TextField
                label="Webサイト（任意）"
                fullWidth
                value={form.website}
                onChange={(e) => setForm({ ...form, website: e.target.value })}
                sx={{ mb: 2 }}
              />
              <TextField
                label="パスワード（8文字以上）"
                type="password"
                fullWidth
                required
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                sx={{ mb: 2 }}
              />
              <TextField
                label="パスワード（確認）"
                type="password"
                fullWidth
                required
                value={form.confirmPassword}
                onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
                sx={{ mb: 3 }}
              />
              <Button type="submit" variant="contained" fullWidth size="large" disabled={loading}>
                {loading ? '登録中...' : '企業アカウントを作成'}
              </Button>
            </Box>

            <Box sx={{ mt: 3, textAlign: 'center' }}>
              <Typography variant="body2">
                既にアカウントをお持ちの方は{' '}
                <Link component={RouterLink} to="/auth/company-login">ログイン</Link>
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default CompanyRegisterPage;
